<template>
    <div class="inspiration-page">
        <!-- 灵感内容区域（包含loading遮罩） -->
        <div class="relative min-h-[400px]">
            <!-- Loading遮罩层 - 只遮盖列表区域 -->
            <div v-if="isUpdatingData" class="absolute inset-0 z-10 flex items-center justify-center">
                <div class="text-center">
                    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#99F768] mx-auto mb-4"></div>
                    <div class="text-white text-lg font-medium mb-2">{{ t('menus.explorePage.loading') }}</div>
                    <div class="text-white/70 text-sm">{{ t('menus.explorePage.pleaseWait') }}</div>
                </div>
            </div>

            <!-- 灵感列表 -->
            <div v-if="!isUpdatingData" class="inspiration-content">

                <!-- 视频tab：瀑布流布局 -->
                <div v-if="activeTab === 'video' && inspirationList.length > 0" ref="containerRef"
                    class="waterfall-container" :style="{ height: `${containerHeight}px` }">
                    <div v-for="item in waterfall.items" :key="item.id" class="waterfall-item cursor-pointer"
                        :style="item.style" @click="handleItemClick(item)">
                        <div class="media-wrapper-waterfall">
                            <div class="media-image-container-waterfall">
                                <!-- 使用ImageLazy组件 -->
                                <ImageLazy :src="item.output" :alt="item.type_name"
                                    :is-video="item.type?.includes('VIDEO')" :autoplay="false"
                                    :allow-load="!isUpdatingData" root-margin="100px" container-class="w-full h-full"
                                    image-class="media-image" placeholder-class="media-image bg-gray-800"
                                    @load="onMediaLoadForWaterfall" />
                                <!-- 左上角icon -->
                                <div class="media-badge">
                                    <span class="badge-icon i-explore-video-icon"></span>
                                </div>
                            </div>
                            <!-- 底部信息 -->
                            <div class="media-overlay">
                                <div class="user-info">
                                    <div class="avatar" :style="{ backgroundImage: `url(${item.user?.avatar})` }"></div>
                                    <span class="username">{{ item.user?.user_name || '' }}</span>
                                </div>
                                <div class="like-info" @click.stop="handleLikeClick($event, item)">
                                    <!-- 未点赞：灰色描边 -->
                                    <svg v-if="!item.has_like" width="11" height="11" viewBox="0 0 11 11" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="like-icon">
                                        <path
                                            d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                            stroke="#71717A" stroke-width="0.916667" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <!-- 已点赞：红色填充 -->
                                    <svg v-else width="11" height="11" viewBox="0 0 11 11" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="like-icon liked">
                                        <path
                                            d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                            fill="#FF5353" />
                                    </svg>
                                    <span class="like-count">{{ formatNumber(item.likes_num || 0) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 图片tab：瀑布流布局 -->
                <div v-else-if="activeTab === 'image' && inspirationList.length > 0" ref="containerRef"
                    class="waterfall-container" :style="{ height: `${containerHeight}px` }">
                    <div v-for="item in waterfall.items" :key="item.id" class="waterfall-item cursor-pointer"
                        :style="item.style" @click="handleItemClick(item)">
                        <div class="media-wrapper-waterfall">
                            <div class="media-image-container-waterfall">
                                <!-- 使用ImageLazy组件 -->
                                <ImageLazy :src="item.output" :alt="item.type_name"
                                    :is-video="item.type?.includes('VIDEO')" :autoplay="false"
                                    :allow-load="!isUpdatingData" root-margin="100px" container-class="w-full h-full"
                                    image-class="media-image" placeholder-class="media-image bg-gray-800"
                                    @load="onMediaLoadForWaterfall" />
                                <!-- 左上角icon -->
                                <div class="media-badge">
                                    <span class="badge-icon i-explore-img-icon"></span>
                                </div>
                            </div>
                            <!-- 底部信息 -->
                            <div class="media-overlay">
                                <div class="user-info">
                                    <div class="avatar" :style="{ backgroundImage: `url(${item.user?.avatar})` }"></div>
                                    <span class="username">{{ item.user?.user_name || '' }}</span>
                                </div>
                                <div class="like-info" @click.stop="handleLikeClick($event, item)">
                                    <!-- 未点赞：灰色描边 -->
                                    <svg v-if="!item.has_like" width="11" height="11" viewBox="0 0 11 11" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="like-icon">
                                        <path
                                            d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                            stroke="#71717A" stroke-width="0.916667" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <!-- 已点赞：红色填充 -->
                                    <svg v-else width="11" height="11" viewBox="0 0 11 11" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="like-icon liked">
                                        <path
                                            d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                            fill="#FF5353" />
                                    </svg>
                                    <span class="like-count">{{ formatNumber(item.likes_num || 0) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 音乐tab：grid布局 -->
                <div v-else-if="activeTab === 'music' && inspirationList.length > 0"
                    class="grid grid-cols-2 gap-x-[10px] gap-y-[15px] transition-opacity duration-300">
                    <div v-for="item in inspirationList" :key="item.id" class="music-item cursor-pointer"
                        @click="handleItemClick(item)">
                        <div class="music-wrapper">
                            <!-- 背景层：图片 + 高斯模糊 -->
                            <div class="music-card-bg" :style="{ backgroundImage: `url(${item.output})` }"></div>

                            <!-- 左上角播放icon -->
                            <div class="music-badge">
                                <img src="~/assets/images/explore/music.svg" alt="music" class="badge-icon" />
                            </div>

                            <!-- 黑胶唱片 -->
                            <div class="vinyl-record">
                                <div class="vinyl-outer"></div>
                                <div class="vinyl-inner">
                                    <ImageLazy :src="item.output" :alt="item.music?.music_title || ''"
                                        :allow-load="!isUpdatingData" root-margin="100px"
                                        container-class="w-full h-full" image-class="vinyl-cover"
                                        placeholder-class="vinyl-cover bg-gray-800" />
                                    <div class="vinyl-center-dot"></div>
                                </div>
                            </div>
                            <!-- 音乐信息 -->
                            <div class="music-info">
                                <h3 class="music-title">{{ item.music?.music_title || '' }}</h3>
                                <div class="music-bottom">
                                    <div class="user-info">
                                        <div class="avatar" :style="{ backgroundImage: `url(${item.user?.avatar})` }">
                                        </div>
                                        <span class="username">{{ item.user?.user_name || '' }}</span>
                                    </div>
                                    <div class="like-info" @click.stop="handleLikeClick($event, item)">
                                        <!-- 未点赞：灰色描边 -->
                                        <svg v-if="!item.has_like" width="11" height="11" viewBox="0 0 11 11"
                                            fill="none" xmlns="http://www.w3.org/2000/svg" class="like-icon">
                                            <path
                                                d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                                stroke="#71717A" stroke-width="0.916667" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <!-- 已点赞：红色填充 -->
                                        <svg v-else width="11" height="11" viewBox="0 0 11 11" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" class="like-icon liked">
                                            <path
                                                d="M0.916992 4.35416C0.917002 3.84413 1.07172 3.3461 1.36072 2.92584C1.64972 2.50559 2.0594 2.18288 2.53565 2.00035C3.0119 1.81781 3.53231 1.78404 4.02816 1.90348C4.52401 2.02292 4.97197 2.28996 5.31287 2.66933C5.33688 2.695 5.36591 2.71547 5.39815 2.72946C5.4304 2.74346 5.46517 2.75068 5.50033 2.75068C5.53548 2.75068 5.57025 2.74346 5.6025 2.72946C5.63475 2.71547 5.66377 2.695 5.68778 2.66933C6.02761 2.28749 6.47567 2.01821 6.97232 1.89732C7.46898 1.77642 7.99068 1.80966 8.46798 1.99259C8.94528 2.17553 9.35554 2.4995 9.64417 2.92137C9.9328 3.34324 10.0861 3.84301 10.0837 4.35416C10.0837 5.40375 9.39616 6.1875 8.70866 6.875L6.19149 9.31012C6.10609 9.40821 6.00079 9.487 5.8826 9.54126C5.7644 9.59552 5.63601 9.62401 5.50596 9.62484C5.3759 9.62566 5.24716 9.5988 5.12829 9.54604C5.00942 9.49328 4.90313 9.41583 4.81649 9.31883L2.29199 6.875C1.60449 6.1875 0.916992 5.40833 0.916992 4.35416Z"
                                                fill="#FF5353" />
                                        </svg>
                                        <span class="like-count">{{ formatNumber(item.likes_num || 0) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 加载状态提示 -->
                <div v-if="!isUpdatingData && loading" class="text-center py-8 mt-4">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#99F768] mx-auto"></div>
                </div>

                <!-- 错误状态提示 -->
                <div v-if="!isUpdatingData && error" class="text-center py-4 mt-4">
                    <p class="text-white/60 text-sm">{{ t('menus.explorePage.loadFailed') }}</p>
                </div>

                <!-- 没有更多数据提示 -->
                <div v-if="!isUpdatingData && finished && inspirationList.length > 0"
                    class="text-center py-4 mt-4 text-white/40 text-sm">
                    {{ t('menus.explorePage.noMore') }}
                </div>

                <!-- 暂无数据提示 -->
                <div v-if="!isUpdatingData && !loading && !error && inspirationList.length === 0"
                    class="flex flex-col items-center justify-center py-20">
                    <div class="text-white/40 text-base">{{ t('menus.explorePage.noContent') }}</div>
                </div>
            </div>
        </div>

        <!-- 详情弹窗 -->
        <!-- 音乐类型：使用 ToolUgcDetailItemInfo -->
        <tool-ugc-detail-item-info v-if="showMask && activeTab === 'music'" :showDataItemInfo="currentDetailItem"
            @closeMask="() => { showMask = false }" @changeLikeStateForItem="changeLikeStateForItem" />

        <!-- 图片/视频类型：使用 MobileUgcDetailItemInfo -->
        <MobileUgcDetailItemInfo v-else-if="showMask && activeTab !== 'music'" :showDataItemInfo="currentDetailItem"
            @closeMask="() => { showMask = false }" @changeLikeStateForItem="changeLikeStateForItem" />
    </div>
</template>

<script setup lang="ts">
import { ref, inject, watch, onMounted, onUnmounted, nextTick, computed, type Ref } from 'vue'
import { getInspirationListApi, changeUserLikeStateApi } from '~/api/inspiration'
import { useI18n } from '~/composables/useI18n'
import ImageLazy from '~/components/mate/ImageLazy.vue'
import MobileUgcDetailItemInfo from '~/components/mobile/MobileUgcDetailItemInfo.vue'

// 灵感页面 - 作为 /explore 的默认子路由

// 国际化
const { t } = useI18n()

// 从父组件获取当前激活的tab
const activeTab = inject<Ref<string>>('activeTab', ref('image'))

// 数据状态
const inspirationList = ref<any[]>([])
const loading = ref(false)
const error = ref(false)
const finished = ref(false)
const page = ref(1)
const pageSize = 20
const isUpdatingData = ref(true)

// ==================== 瀑布流配置（用于 image 和 video tab）====================
const config = {
    baseColumnWidth: 180, // 移动端基准列宽
    gap: 10, // 间距
    minColumns: 2, // 固定2列
    defaultAspectRatio: 3 / 4, // 默认宽高比
}

// 容器引用
const containerRef = ref<HTMLElement | null>(null)

// 瀑布流状态
const waterfall = ref({
    columns: 2,
    columnWidth: config.baseColumnWidth,
    columnHeights: [] as number[],
    items: [] as any[],
})

// 计算列数和列宽（移动端固定2列）
const calculateColumnsAndWidth = () => {
    if (!containerRef.value) {
        return { columns: config.minColumns, columnWidth: config.baseColumnWidth }
    }

    const containerWidth = containerRef.value.offsetWidth
    const columns = config.minColumns // 移动端固定2列

    // 根据2列计算最佳列宽
    const columnWidth = (containerWidth - (columns - 1) * config.gap) / columns

    return { columns, columnWidth }
}

// 初始化列高度数组
const initColumnHeights = (columnCount: number) => {
    waterfall.value.columnHeights = new Array(columnCount).fill(0)
}

// 获取最短列的索引
const getShortestColumnIndex = () => {
    const minHeight = Math.min(...waterfall.value.columnHeights)
    return waterfall.value.columnHeights.indexOf(minHeight)
}

// 计算元素的高度（基于宽高比）
const calculateItemHeight = (item: any) => {
    let aspectRatio = config.defaultAspectRatio

    // 如果有宽高比信息，使用它
    if (item.param?.aspect_ratio) {
        const ratioStr = item.param.aspect_ratio
        if (ratioStr && ratioStr.includes(':')) {
            const parts = ratioStr.split(':')
            const width = Number(parts[0])
            const height = Number(parts[1])

            if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
                aspectRatio = width / height
            }
        }
    }

    const height = Math.ceil(waterfall.value.columnWidth / aspectRatio)
    return height
}

// 布局单个元素
const layoutItem = (item: any, index: number) => {
    const columnIndex = getShortestColumnIndex()
    const itemHeight = calculateItemHeight(item)
    const left = columnIndex * (waterfall.value.columnWidth + config.gap)
    const top = waterfall.value.columnHeights[columnIndex]

    const waterfallItem = {
        ...item,
        style: {
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            width: `${waterfall.value.columnWidth}px`,
            height: `${itemHeight}px`,
        },
    }

    if (!isNaN(itemHeight) && itemHeight > 0) {
        waterfall.value.columnHeights[columnIndex]! += itemHeight + config.gap
    }

    return waterfallItem
}

// 执行瀑布流布局
const layout = () => {
    // 图片和视频都使用瀑布流布局
    if (!containerRef.value || (activeTab.value !== 'video' && activeTab.value !== 'image')) return

    const { columns, columnWidth } = calculateColumnsAndWidth()

    waterfall.value.columns = columns
    waterfall.value.columnWidth = columnWidth

    initColumnHeights(columns)

    waterfall.value.items = []
    inspirationList.value.forEach((item, index) => {
        const waterfallItem = layoutItem(item, index)
        waterfall.value.items.push(waterfallItem)
    })
}

// 计算容器总高度（取最高列）
const containerHeight = computed(() => {
    const validHeights = waterfall.value.columnHeights.filter(
        h => typeof h === 'number' && !isNaN(h)
    )
    return validHeights.length > 0 ? Math.max(...validHeights) : 0
})

// 图片/视频加载完成后重新计算（用于瀑布流）
const onMediaLoadForWaterfall = () => {
    // 图片和视频都需要重新布局
    if (activeTab.value === 'video' || activeTab.value === 'image') {
        // 延迟布局，等待图片真正加载完成
        nextTick(() => {
            layout()
        })
    }
}

// 监听窗口大小变化
let resizeTimer: ReturnType<typeof setTimeout> | null = null
const handleResize = () => {
    // 图片和视频都需要响应窗口大小变化
    if (activeTab.value === 'video' || activeTab.value === 'image') {
        if (resizeTimer) clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
            layout()
        }, 150)
    }
}

// 类型映射
const typeMapping = {
    image: [
        'TEXT_TO_IMG',
        'IMG_TO_IMG',
        'IMAGE_EFFECT_TEMPLATE_CREATION',
    ],
    video: [
        'TEXT_TO_VIDEO',
        'IMG_TO_VIDEO',
        'VIDEO_EFFECT_TEMPLATE_CREATION',
    ],
    music: [
        'MUSIC_CREATION_GENERATION',
    ],
}

// 当前使用的types
const currentTypes = computed(() => {
    return typeMapping[activeTab.value as keyof typeof typeMapping] || typeMapping.image
})

// 加载灵感列表
const loadInspirationList = async (isLoadMore = false) => {
    try {
        loading.value = true
        error.value = false

        const response = await getInspirationListApi({
            page: page.value,
            size: pageSize,
            types: currentTypes.value,
        })

        if (response && response.status === 200 && response.data) {
            if (!isLoadMore && isUpdatingData.value) {
                isUpdatingData.value = false
                await nextTick()
            }

            if (isLoadMore) {
                inspirationList.value.push(...(response.data.content || []))
            } else {
                inspirationList.value = response.data.content || []
            }

            // 判断是否还有更多数据：当前页数 >= 总页数
            finished.value = page.value >= response.data.total_page

            // 如果是 image 或 video tab，执行瀑布流布局
            if (activeTab.value === 'image' || activeTab.value === 'video') {
                await nextTick()
                // 等待 containerRef 挂载
                setTimeout(() => {
                    layout()
                }, 100)
            }
        } else {
            error.value = true
        }
    } catch (err) {
        console.error('加载灵感列表失败:', err)
        error.value = true
    } finally {
        loading.value = false
        isUpdatingData.value = false
    }
}

// 获取媒体URL
const getMediaUrl = (item: any) => {
    // 优先使用output，如果是视频则使用output_with_watermark的第一帧
    // 对于视频，暂时先用output（后续可以考虑添加视频封面字段）
    if (item.type?.includes('VIDEO')) {
        // 视频使用output字段（浏览器会自动显示第一帧）
        return item.output
    }
    return item.output || item.output_with_watermark
}

// 格式化数字
const formatNumber = (num: number) => {
    if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'
    }
    return num.toString()
}

// 弹窗控制
const showMask = ref(false)
const currentDetailItem = ref<any>(null)

// 点击灵感项 - 打开详情弹窗
const handleItemClick = (item: any) => {
    showMask.value = true

    // 根据类型处理数据
    if (activeTab.value === 'music') {
        // 音乐类型需要转换数据格式
        currentDetailItem.value = {
            ...item,
            music: {
                music_title: item.music?.music_title || item.param?.prompt || '',
                generated_lyrics: item.music?.generated_lyrics || '',
                music_style: item.param?.styles?.join(', ') || '',
            },
        }
    } else {
        // 图片/视频直接使用原数据
        currentDetailItem.value = item
    }
}

// 处理列表中的点赞点击
const handleLikeClick = async (event: MouseEvent, item: any) => {
    event.stopPropagation() // 阻止冒泡，防止触发 item 点击打开详情
    await changeLikeStateForItem(event, item)
}

// 更新点赞状态
const changeLikeStateForItem = async (event: MouseEvent, item: any) => {
    if (!item) return

    event?.preventDefault?.()

    const inspirationId = item.ins_id
    const prevHasLike = !!item?.has_like
    const prevLikes = item?.likes_num ?? 0
    const nextHasLike = !prevHasLike
    const nextLikes = nextHasLike ? prevLikes + 1 : Math.max(0, prevLikes - 1)

    // 找到列表中的对应项并更新
    const listItem = inspirationList.value.find(i => i.ins_id === inspirationId)
    const detailItem = currentDetailItem.value?.ins_id === inspirationId ? currentDetailItem.value : null

        // 同步更新UI
        ;[item, listItem, detailItem].forEach(i => {
            if (i) {
                i.has_like = nextHasLike
                i.likes_num = nextLikes
            }
        })

    // 调用API
    try {
        const res = await changeUserLikeStateApi({
            ins_id: inspirationId,
            like: nextHasLike,
        })

        if (res.status !== 200) {
            // 失败则恢复状态
            ;[item, listItem, detailItem].forEach(i => {
                if (i) {
                    i.has_like = prevHasLike
                    i.likes_num = prevLikes
                }
            })
        }
    } catch (err) {
        console.error('点赞操作失败:', err)
            // 失败则恢复状态
            ;[item, listItem, detailItem].forEach(i => {
                if (i) {
                    i.has_like = prevHasLike
                    i.likes_num = prevLikes
                }
            })
    }
}

// 监听弹窗状态，控制 body 滚动
watch(showMask, (newVal) => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    if (newVal) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = ''
    }
})

// 滚动容器引用
const scrollContainer = ref<HTMLElement | Window | null>(null)

// 查找真正的滚动容器
const findScrollContainer = (element: HTMLElement | null): HTMLElement | Window => {
    if (!element) return window

    let parent = element.parentElement
    // 用于存储第一个"潜在"的滚动容器（有 overflow-y: auto/scroll 但内容暂时没有超出）
    let potentialContainer: HTMLElement | null = null

    while (parent) {
        const style = window.getComputedStyle(parent)
        const overflowY = style.overflowY

        // 找到第一个可滚动的父容器
        if (overflowY === 'auto' || overflowY === 'scroll') {
            // 如果内容已经超出容器高度，立即返回
            if (parent.scrollHeight > parent.clientHeight) {
                return parent
            }
            // 否则记录为潜在容器（内容加载后可能会变成真正的滚动容器）
            if (!potentialContainer) {
                potentialContainer = parent
            }
        }

        parent = parent.parentElement
    }

    // 如果没找到实际滚动的容器，但有潜在容器，返回潜在容器
    if (potentialContainer) {
        return potentialContainer
    }

    return window
}

// 获取滚动信息
const getScrollInfo = () => {
    if (!scrollContainer.value) return null

    if (scrollContainer.value === window) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollHeight = document.documentElement.scrollHeight
        const clientHeight = window.innerHeight
        return { scrollTop, scrollHeight, clientHeight }
    } else {
        const element = scrollContainer.value as HTMLElement
        return {
            scrollTop: element.scrollTop,
            scrollHeight: element.scrollHeight,
            clientHeight: element.clientHeight,
        }
    }
}

// 自定义滚动监听
const handleScroll = () => {
    if (loading.value || finished.value || error.value || isUpdatingData.value) {
        return
    }

    const scrollInfo = getScrollInfo()
    if (!scrollInfo) return

    const { scrollTop, scrollHeight, clientHeight } = scrollInfo
    const distanceToBottom = scrollHeight - scrollTop - clientHeight

    if (distanceToBottom < 150) {
        page.value++
        loadInspirationList(true)
    }
}

// 节流
let scrollTimer: ReturnType<typeof setTimeout> | null = null
const throttledHandleScroll = () => {
    if (scrollTimer) return
    scrollTimer = setTimeout(() => {
        handleScroll()
        scrollTimer = null
    }, 100)
}

// 设置滚动监听
const setupScrollListener = () => {
    // 移除旧的监听
    if (scrollContainer.value) {
        scrollContainer.value.removeEventListener('scroll', throttledHandleScroll)
    }

    // 查找并设置滚动容器
    const pageElement = document.querySelector('.inspiration-page') as HTMLElement
    let container = findScrollContainer(pageElement)

    // 关键修复：检查找到的容器是否真的能滚动
    // 如果容器的 scrollHeight <= clientHeight，说明内容没有超出，真正的滚动发生在 window
    if (container !== window) {
        const el = container as HTMLElement
        if (el.scrollHeight <= el.clientHeight) {
            container = window
        }
    }

    scrollContainer.value = container

    // 添加监听
    if (scrollContainer.value) {
        scrollContainer.value.addEventListener('scroll', throttledHandleScroll, { passive: true })
    }
}

// 监听tab切换
watch(activeTab, async (newTab, oldTab) => {
    if (newTab !== oldTab && newTab !== 'characters') {
        // 重置数据
        page.value = 1
        finished.value = false
        inspirationList.value = []
        waterfall.value.items = []
        isUpdatingData.value = true
        // 重新加载
        await loadInspirationList()
        // 重新设置滚动监听
        nextTick(() => {
            setupScrollListener()
        })
    }
})

onMounted(async () => {
    await loadInspirationList()
    // 数据加载完成后设置滚动监听
    nextTick(() => {
        setupScrollListener()
    })
    window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
    // 移除滚动监听
    if (scrollContainer.value) {
        scrollContainer.value.removeEventListener('scroll', throttledHandleScroll)
    }
    window.removeEventListener('resize', handleResize)

    if (scrollTimer) {
        clearTimeout(scrollTimer)
        scrollTimer = null
    }

    if (resizeTimer) {
        clearTimeout(resizeTimer)
        resizeTimer = null
    }

    // 清理body滚动状态
    if (typeof document !== 'undefined') {
        document.body.style.overflow = ''
    }
})
</script>

<style scoped lang="less">
.inspiration-page {
    min-height: 100%;
    position: relative;
}

.inspiration-content {
    min-height: 400px;
}

// ==================== 瀑布流容器样式（用于 image 和 video tab）====================
.waterfall-container {
    position: relative;
    width: 100%;
    min-height: 400px;
    transition: height 0.3s ease;
}

.waterfall-item {
    border-radius: 10.5px;
    overflow: hidden;
    cursor: pointer;
}

.media-wrapper-waterfall {
    position: relative;
    width: 100%;
    height: 100%;
    background: #18181B;
    border: 1px solid rgba(39, 39, 42, 0.3);
    border-radius: 10.5px;
    overflow: hidden;
    box-shadow:
        0px 2px 4px -2px rgba(0, 0, 0, 0.1),
        0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.media-image-container-waterfall {
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    background: #27272A;
    overflow: hidden;
}

// 图片/视频样式（grid布局用于 image tab）
.media-item {
    width: 100%;
}

.media-wrapper {
    position: relative;
    background: #18181B;
    border: 1px solid rgba(39, 39, 42, 0.3);
    border-radius: 10.5px;
    overflow: hidden;
    box-shadow:
        0px 2px 4px -2px rgba(0, 0, 0, 0.1),
        0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.media-image-container {
    position: relative;
    width: 100%;
    height: 140px; // 固定高度
    flex-shrink: 0;
    background: #27272A; // 占位符背景色
    overflow: hidden;
}

.media-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.media-badge {
    position: absolute;
    top: 9.75px;
    left: 9.75px;
    padding: 3.5px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5.25px;
    backdrop-filter: blur(12px);
    box-shadow:
        0px 4px 6px -4px rgba(0, 0, 0, 0.1),
        0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 2;

    .badge-icon {
        width: 10px;
        height: 10px;
        display: block;
        background-color: #FFFFFF;
    }
}

.media-overlay {
    padding: 7px;
    background: rgba(9, 9, 11, 0.4);
    backdrop-filter: blur(12px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

// 瀑布流中的 media-overlay 需要绝对定位
.waterfall-item .media-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 5.25px;
    flex: 1;
    min-width: 0; // 允许flex子元素缩小

    .avatar {
        width: 17.5px;
        height: 17.5px;
        border-radius: 9999px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background-color: #27272A;
        background-size: cover;
        background-position: center;
        flex-shrink: 0;
    }

    .username {
        font-family: 'PingFang SC', sans-serif;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.5;
        color: #D4D4D8;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
    }
}

.like-info {
    display: flex;
    align-items: center;
    gap: 3.5px;
    flex-shrink: 0; // 防止被压缩
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }

    .like-icon {
        width: 11px;
        height: 11px;
        flex-shrink: 0;
        transition: all 0.2s ease;

        &.liked {
            animation: likeAnimation 0.3s ease;
        }
    }

    .like-count {
        font-family: 'Inter', sans-serif;
        font-size: 11px;
        font-weight: 700;
        line-height: 1.5;
        color: #71717A;
        white-space: nowrap;
    }
}

// 音乐样式
.music-item {
    width: 100%;
}

.music-wrapper {
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 21px;
    padding: 14px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

// 背景层：图片 + 高斯模糊
.music-card-bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    transform: scale(1.1); // 防止模糊边缘露出
    z-index: 0;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.3);
    }
}

.music-badge {
    position: absolute;
    top: 9.67px; // Figma设计中的位置
    left: 10.5px; // Figma设计中的位置
    padding: 3.5px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5.25px;
    backdrop-filter: blur(12px);
    box-shadow:
        0px 4px 6px -4px rgba(0, 0, 0, 0.1),
        0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 2;

    .badge-icon {
        width: 10px;
        height: 10px;
        display: block;
    }
}

// 黑胶唱片样式
.vinyl-record {
    width: 145.75px; // 固定宽度
    height: 145.75px; // 固定高度
    position: relative;
    z-index: 1;
    margin-bottom: 14px;
    background: #27272A; // 占位符背景色
    border-radius: 50%;
    flex-shrink: 0;
}

.vinyl-outer {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background-color: rgba(8, 8, 8);
}

.vinyl-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 89%; // 内圈占外圈的89%
    height: 89%;
    border-radius: 50%;
    overflow: hidden;
}

.vinyl-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.vinyl-center-dot {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 1);
    border: 2px solid rgba(51, 51, 51, 1);
    box-sizing: border-box;
}

.music-info {
    display: flex;
    flex-direction: column;
    gap: 9px; // Figma设计中的间距
    position: relative;
    z-index: 1;
}

.music-title {
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    color: #FFFFFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
}

.music-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20.69px;
    position: relative;
    z-index: 1;

    .user-info {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 5.25px;

        .avatar {
            width: 17.5px;
            height: 17.5px;
            border-radius: 9999px;
            border: 1px solid rgba(255, 255, 255, 0.05);
            background-color: #27272A;
            background-size: cover;
            background-position: center;
            flex-shrink: 0;
        }

        .username {
            font-family: 'PingFang SC', sans-serif;
            font-size: 12px;
            font-weight: 600;
            color: #D4D4D8;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
            min-width: 0;
        }
    }

    .like-info {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 3.5px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.95);
        }

        .like-icon {
            width: 14px;
            height: 14px;
            flex-shrink: 0;
            transition: all 0.2s ease;

            &.liked {
                animation: likeAnimation 0.3s ease;
            }
        }

        .like-count {
            font-family: 'Inter', sans-serif;
            font-size: 12px;
            font-weight: 600;
            color: #FFFFFF;
            white-space: nowrap;
        }
    }
}

// Icon样式定义（必须在scoped中定义才能生效）
.i-explore-img-icon {
    mask: url('~/assets/images/explore/img.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/explore/img.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
}

.i-explore-video-icon {
    mask: url('~/assets/images/explore/video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/explore/video.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
}

.i-explore-mp3-icon {
    mask: url('~/assets/images/explore/MP3.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/explore/MP3.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
}

// 点赞动画
@keyframes likeAnimation {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.3);
    }

    100% {
        transform: scale(1);
    }
}

// PC端适配
@media (min-width: 768px) {
    .inspiration-page {
        padding: 32px 40px;
    }

    .inspiration-content {
        .grid {
            grid-template-columns: repeat(auto-fill, minmax(175.75px, 1fr));
        }
    }
}
</style>
